<div class="shopping-cart">
  <div class="header">
    <h4 class="bold mb-3">{{ "shoppingCart.title" | translate }}</h4>
  </div>

  @if (showCampaignCodeRow) {
    <div class="row">
      <div class="col-12 col-lg-8">
        <vw-text-box
          [label]="'shoppingCart.campaignCode.title' | translate"
          [parentForm]="campaignCodeForm"
          [formControlProp]="'campaignCode'"
          [labelClass]="'primary'"
          [type]="'text'"
          [id]="'campaign-code'"
        ></vw-text-box>
      </div>
      <div class="col-12 col-lg-4 mt-auto mb-3">
        <vw-button
          [text]="
            (!!isCampaignCodeApplied
              ? 'shoppingCart.campaignCode.remove'
              : 'shoppingCart.campaignCode.apply'
            ) | translate
          "
          [primary]="true"
          [disabled]="
            !campaignCodeForm.controls.campaignCode.value?.trim() ||
            !campaignCodeForm.controls.campaignCode.dirty
          "
          (click$)="validateAndApplyOrRemoveCampaignCode()"
        ></vw-button>
      </div>
    </div>

    @if (
      campaignCodeForm.controls.campaignCode.dirty && isInvalidCampaignCode
    ) {
      <div class="row">
        <vw-alert
          [message]="'shoppingCart.campaignCode.invalid' | translate"
          type="danger"
        ></vw-alert>
      </div>
    }
  }

  <div class="content">
    <vw-alert
      *ngIf="!shoppingCartService.shoppingCart?.shoppingCartItems?.length"
      type="info"
      [message]="'infoMessages.shoppingCartEmpty' | translate"
    >
    </vw-alert>

    <vw-alert
      *ngIf="!modelAndDealerService.selectedDealer"
      type="info"
      [message]="'infoMessages.noDealerSelected' | translate"
    >
    </vw-alert>

    <vw-alert
      *ngIf="shoppingCartService?.productExceptions?.length"
      [type]="'info'"
    >
      <i class="fal fa-exclamation-triangle me-1"></i>
      <span>{{ "shoppingCart.productsDontMatchMessage" | translate }}</span>
    </vw-alert>

    <vw-alert
      *ngIf="
        !!channelRequestService.channelRequest &&
        !!channelRequestService.channelRequest.shoppingCart &&
        !!channelRequestService.channelRequest.shoppingCart.vehicle &&
        !channelRequestService.channelRequest.shoppingCart.vehicle.vin &&
        !channelRequestService.channelRequest.shoppingCart.vehicle.licensePlate
      "
      [type]="'info'"
      [message]="'infoMessages.vehicleSelectedByModel' | translate"
    >
    </vw-alert>

    <div class="products" *ngIf="shoppingCartService.hasItems">
      <div class="header">
        <span class="order">{{ "shoppingCart.order" | translate }}</span>
      </div>

      <div
        class="product"
        *ngFor="let i of shoppingCartService.shoppingCart?.shoppingCartItems"
      >
        <ng-container *ngIf="i.product">
          <div class="row align-items-start align-items-sm-center">
            <div class="col-3 my-2">
              <a
                [routerLink]="[
                  '/' + themeService.brand,
                  'product',
                  i.product.sku
                ]"
              >
                <img
                  class="image-aspect-ratio"
                  [alt]="i.product.sku"
                  [src]="
                    i.product.media
                      | productImageURL: settingNames.ProductImageSmall
                  "
                  vwProductImageFallback
              /></a>
            </div>
            <div
              class="d-flex flex-column flex-sm-row col-9 align-items-center"
            >
              <div class="col-12 col-sm-5">
                <i
                  class="fal fa-exclamation-triangle me-1"
                  *ngIf="
                    i.product.sku != null &&
                    shoppingCartService.productExceptions.includes(
                      i.product.sku
                    )
                  "
                ></i>
                <a
                  [routerLink]="[
                    '/' + themeService.brand,
                    'product',
                    i.product.sku
                  ]"
                >
                  <span
                    class="d-block product-subset"
                    *ngIf="!!i.product.productSubset?.length"
                    >{{ "productSubset" | translate }}</span
                  >
                  <span class="product-name">{{
                    i.product.media
                      | media
                        : mediaCategoryTypeNames.ProductName
                        : mediaTypes.Text
                  }}</span>
                </a>
              </div>
              <div class="col-12 col-sm-3">
                <div class="product-quantity">
                  <i
                    class="fal fa-minus"
                    (click)="decreaseQuantity(i.shoppingCartItemId)"
                    *ngIf="
                      i.shoppingCartItemId != null &&
                      i.quantity != null &&
                      (!i.product.minimumQuantity ||
                        i.quantity - 1 >= i.product.minimumQuantity)
                    "
                  ></i>

                  <i
                    class="fal fa-trash-alt"
                    *ngIf="
                      i.shoppingCartItemId != null &&
                      i.quantity === i.product.minimumQuantity
                    "
                    (click)="deleteItem(i.shoppingCartItemId)"
                  ></i>

                  <span class="me-2 ms-2">{{ i.quantity }}</span>

                  <i
                    class="fal fa-plus"
                    (click)="increaseQuantity($event, i.product)"
                    [class.disabled]="
                      i.quantity == null ||
                      (i.product.maximumQuantity &&
                        i.quantity + 1 > i.product.maximumQuantity)
                    "
                  ></i>
                </div>
              </div>
              <div
                *ngIf="
                  i.product.price != null && i.product.price.salesPrice != null
                "
                class="col-12 col-sm-4 text-start text-sm-end"
              >
                <div class="prices">
                  <div
                    *ngIf="
                      i.product.isCampaign && !!i.product.price.listPrice;
                      else noCampaign
                    "
                    class="product-campaign-prices"
                  >
                    <span
                      *ngIf="
                        i.product.price.adjustmentPercentage != null &&
                        i.product.price.salesPrice < i.product.price.listPrice
                      "
                      class="percentage"
                      >{{
                        i.product.price.adjustmentPercentage * 100
                          | number: "1.0-0"
                      }}
                      {{ "price.discount" | translate }}</span
                    >
                    <span>{{
                      i.product.price.salesPrice | price: false : i.quantity
                    }}</span>
                    <div
                      *ngIf="
                        i.product.price.salesPrice < i.product.price.listPrice
                      "
                      class="d-flex justify-content-end align-items-center"
                    >
                      <span class="original">{{
                        i.product.price.listPrice | price: false : i.quantity
                      }}</span>
                      <i
                        class="fal fa-info-circle"
                        title="{{ 'price.latest' | translate }}"
                      ></i>
                    </div>
                  </div>
                  <ng-template #noCampaign>
                    <span>
                      {{
                        i.product.price.salesPrice | price: false : i.quantity
                      }}
                    </span>
                  </ng-template>
                  <span class="product-monthly-price">
                    {{ i.product.price.salesPrice | price: true : i.quantity }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div
          *ngIf="!i.product?.price && !!modelAndDealerService.selectedDealer"
          class="row"
        >
          <div class="col-12">
            <i class="fal fa-exclamation-triangle me-2"></i>
            <span>{{ "shoppingCart.noDealerPrice" | translate }}</span>
          </div>
        </div>
        @if (
          !!campaignCodeResponse &&
          !!campaignCodeResponse.isValidCampaignCode &&
          !!isCampaignCodeApplied &&
          !campaignCodeResponse.campaignCodeDetails
            ?.isValidForCampaignProducts &&
          i.product?.isCampaign
        ) {
          <div class="col-12">
            <i class="fal fa-exclamation-triangle me-2"></i>
            <span>{{
              "shoppingCart.campaignCode.productNotIncluded" | translate
            }}</span>
          </div>
        }
      </div>
    </div>

    <div
      class="price"
      *ngIf="
        shoppingCartService.hasItems && modelAndDealerService.selectedDealer
      "
    >
      <div>
        <span>{{ "price.price" | translate }}</span>
        @if (!!totalPriceOriginal && !!isCampaignCodeApplied) {
          <span class="ms-auto me-2 bold text-decoration-line-through"
            >{{ totalPriceOriginal | price }}
          </span>
        }
        <span>{{ shoppingCartService.total | price }}</span>
      </div>

      <div class="total">
        <span>{{ "shoppingCart.total" | translate }}</span>
        <div>
          <span class="bold">{{ shoppingCartService.total | price }}</span>
          <div
            class="d-flex align-items-center"
            *ngIf="shoppingCartService.total >= 500"
          >
            <vw-brand-card class="mx-3"></vw-brand-card>
            <span class="bold monthly-total"
              >{{ shoppingCartService.monthlyTotal | price }} /
              {{ "price.month" | translate }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
